/**
 * Liste sayfalarının arama/filtre/sıralama/sayfa durumunu hatırlar.
 *
 * Bir kaydın güncelleme formuna girip listeye dönüldüğünde tablo, en son
 * seçilen arama metni, sıralama, sayfa ve sayfa boyutu ile açılır.
 *
 * Durum sessionStorage'da, sayfa adına göre ayrı anahtarlarda tutulur:
 * sekme açık kaldığı sürece korunur, sekme kapanınca temizlenir. Böylece
 * ortak kullanılan bir bilgisayarda önceki kullanıcının filtreleri kalmaz.
 *
 * Kullanımı: mixin'i ekle, created() içinde restoreListState() çağır,
 * paginate() içinde saveListState() çağır.
 */

const STORAGE_PREFIX = "listState:";

export default {
    methods: {
        listStateKey() {
            return STORAGE_PREFIX + (this.$options.name || this.$route.name);
        },

        saveListState() {
            try {
                sessionStorage.setItem(
                    this.listStateKey(),
                    JSON.stringify({
                        search: this.search,
                        page: this.page,
                        itemsPerPage: this.itemsPerPage,
                        pageSize: this.pageSize,
                        sortBy: this.sortBy,
                        sortDesc: this.sortDesc
                    })
                );
            } catch (e) {
                // sessionStorage kullanılamıyorsa (gizli sekme, kota dolu)
                // durumu hatırlamamak sorun değil, sayfa çalışmaya devam etsin
            }
        },

        restoreListState() {
            try {
                const saved = sessionStorage.getItem(this.listStateKey());
                if (!saved) {
                    return false;
                }

                const state = JSON.parse(saved);

                if (typeof state.search === "string") {
                    this.search = state.search;
                }
                if (Number.isInteger(state.page) && state.page > 0) {
                    this.page = state.page;
                }
                if (Number.isInteger(state.itemsPerPage) && state.itemsPerPage > 0) {
                    this.itemsPerPage = state.itemsPerPage;
                }
                if (Number.isInteger(state.pageSize) && state.pageSize > 0) {
                    this.pageSize = state.pageSize;
                }
                if (state.sortBy !== undefined && state.sortBy !== null) {
                    this.sortBy = state.sortBy;
                }
                if (state.sortDesc !== undefined && state.sortDesc !== null) {
                    this.sortDesc = state.sortDesc;
                }

                return true;
            } catch (e) {
                return false;
            }
        }
    }
};
